import React, { useCallback, useEffect } from 'react';
import './Navbar.css';
import ConnectButton from '../../Web/ConnectButton';
import { useWallet } from '../../context/WalletContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { API_BASE } from '../../utils/api';

const Navbar = () => {
    const {
        setStatus,
        setBalance,
        setFormStatus,
        setRegistrationLocked,
        setRegisteredEthAddress,
        connectedAddress
    } = useWallet();

    const postWalletAddress = useCallback(async (address) => {
        try {
            const response = await axios.post(`${API_BASE}holder-addresses`, {
                holder_address: address
            });
            setStatus(Boolean(response.data.status));
            setBalance(Number(response.data.balance) || 0);
            setFormStatus(Boolean(response.data.registered));
            setRegistrationLocked(Boolean(response.data.registration_locked));
            setRegisteredEthAddress(response.data.eth_address || '');
            console.log('Response:', response.data);
        } catch (error) {
            setStatus(false);
            setBalance(0);
            setRegistrationLocked(false);
            setRegisteredEthAddress('');
            console.error('Error posting wallet address:', error);
            toast.error('Failed to check Flash token balance.', { autoClose: 1000 });
        }
    }, [setStatus, setBalance, setFormStatus, setRegistrationLocked, setRegisteredEthAddress]);

    useEffect(() => {
        if (!connectedAddress) {
            setStatus(false);
            setBalance(0);
            return;
        }
        postWalletAddress(connectedAddress);
    }, [connectedAddress, setStatus, setBalance, postWalletAddress]);

    return (
        <div>
            <div className='navbar-window'>
                <Link to="/" className='logo-window'>
                    <img src="../../assets/logo.png" alt="Logo" />
                    <strong className='max-[700px]:hidden'>Flash Technologies</strong>
                </Link>
                <ConnectButton />
            </div>
        </div>
    );
};

export default Navbar;
